import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const EMPTY = { time: "", guest_room: "", task_issue: "", action_taken: "", status: "Pending" };
const FIELDS = [
  { key: "time", label: "Time", type: "time", cls: "sm:w-28" },
  { key: "guest_room", label: "Guest / Room", cls: "sm:w-36" },
  { key: "task_issue", label: "Task / Issue", cls: "sm:flex-1" },
  { key: "action_taken", label: "Action Taken", cls: "sm:flex-1" },
];
const inputCls = "w-full text-sm bg-[#FBF9F5] border border-[#E2DAD0] rounded-lg px-3 py-2 focus:outline-none focus:border-[#C87D55] disabled:opacity-80";

export const FollowUpTable = ({ rows, onChange, disabled }) => {
  const update = (i, patch) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <div className="space-y-3" data-testid="followup-table">
      {rows.length === 0 && <p className="text-sm text-[#9A9188]">No follow-ups recorded.</p>}
      {rows.map((r, i) => (
        <div key={i} className="flex flex-col sm:flex-row sm:items-center gap-2 p-3 sm:p-2 rounded-xl border border-[#E2DAD0] bg-white" data-testid={`followup-row-${i}`}>
          <span className="text-xs text-[#9A9188] w-5 hidden sm:block">{i + 1}</span>
          {FIELDS.map((f) => (
            <div key={f.key} className={f.cls}>
              <input type={f.type || "text"} disabled={disabled} placeholder={f.label} value={r[f.key]} data-testid={`followup-${f.key}-${i}`} onChange={(e) => update(i, { [f.key]: e.target.value })} className={inputCls} />
            </div>
          ))}
          <div className="flex items-center gap-2">
            {["Done", "Pending"].map((s) => (
              <button key={s} type="button" disabled={disabled} data-testid={`followup-status-${s.toLowerCase()}-${i}`} onClick={() => update(i, { status: s })}
                className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors duration-200 ${
                  r.status === s ? (s === "Done" ? "bg-[#DCFCE7] text-[#15803D] border-[#15803D]/30" : "bg-[#FEF3C7] text-[#B45309] border-[#B45309]/30") : "border-[#E2DAD0] text-[#9A9188]"
                }`}>{s}</button>
            ))}
            {!disabled && (
              <button type="button" data-testid={`followup-remove-${i}`} onClick={() => onChange(rows.filter((_, j) => j !== i))} className="p-1.5 text-[#9A9188] hover:text-[#B91C1C]">
                <Trash2 className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      ))}
      {!disabled && (
        <Button type="button" variant="outline" data-testid="followup-add-button" onClick={() => onChange([...rows, { ...EMPTY }])} className="rounded-full">
          <Plus className="w-4 h-4 mr-1" /> Add follow-up
        </Button>
      )}
    </div>
  );
};
